export const getCallEvidenceState = ({ recordingAvailable, transcriptAvailable }) => {
  if (recordingAvailable && transcriptAvailable) return 'recording_and_transcript';
  if (recordingAvailable) return 'recording_only';
  if (transcriptAvailable) return 'transcript_only';
  return 'no_recording_or_transcript';
};
